export const TIMECLOCK = "timeclock";
export const NORMAL = "normal";
export const SUPER = "super";


// WEBPACK FOOTER //
// ./src/constants/userTypes.js